import { render } from "./StatisticsOverview.vue?vue&type=template&id=78318e46"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__